import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Monitor, Pause, Trash2 } from "lucide-react";

export function DebugMonitor() {
  return (
    <>
      <h3 className="text-center text-lg">I think this entire tab can go</h3>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Monitor className="w-5 h-5" />
                Real-time Debug Monitor
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="h-96 overflow-y-auto space-y-2 p-2 bg-muted/50 rounded font-mono text-sm">
                <div className="text-success">
                  [14:32:01] Connection established to MCP server
                </div>
                <div className="text-muted-foreground">
                  [14:32:15] Tool call: search_files(query="*.ts")
                </div>
                <div className="text-primary">
                  [14:32:16] Response: 3 files found
                </div>
                <div className="text-muted-foreground">
                  [14:32:30] Tool call: read_file(path="src/index.ts")
                </div>
                <div className="text-primary">
                  [14:32:31] Response: 147 bytes read
                </div>
                <div className="text-warning">
                  [14:32:45] Rate limit warning: 80% of quota used
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle className="text-sm">Monitor Controls</CardTitle>
            </CardHeader>
            <CardContent className="space-y-2">
              <Button variant="outline" size="sm" className="w-full">
                <Pause className="w-4 h-4 mr-2" />
                Pause Monitor
              </Button>
              <Button variant="outline" size="sm" className="w-full">
                <Trash2 className="w-4 h-4 mr-2" />
                Clear Logs
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-sm">Debug Stats</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Events Logged</span>
                <span>247</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Errors</span>
                <span className="text-destructive">3</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Warnings</span>
                <span className="text-warning">8</span>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
}
